// Opening the quick-log quiz from anywhere: the "+" in the tab bar, smart hints on Today, the "since last" tiles on Track.
// QuickLog (mounted once in the app shell) listens for this event and opens its sheet at the given flow.
export type QuickFlow = 'start' | 'sleep' | 'feed' | 'diaper' | 'med';
export const QUICKLOG_EVENT = 'bp:quicklog';

export function openQuickLog(flow: QuickFlow = 'start', source = 'fab') {
  window.dispatchEvent(new CustomEvent(QUICKLOG_EVENT, { detail: { flow, source } }));
}
